module.exports = __webpack_public_path__ + "img/clint9.3c73ecde.png";